import { TEMPLATE_NAMES } from '@/cms/constants/template-names'
import { createReactHybridPageRegistry } from '@/cms/reactHybridPageRegistry'
import { createReactPageRegistry } from '@/cms/reactPageRegistry'
import { isDestinationPage, isPDP } from '@/cms/reactPageRegistryRules'
import { BookingDetails } from '@/scopes/account/booking-details/pages'
import { BookingPaymentPage, GroupsTotallySnowBookingPaymentPage, GroupsWinterBookingPaymentPage } from '@/scopes/account/booking-payment/pages'
import { BookingsOverview } from '@/scopes/account/bookings-overview/pages'
import { GroupsResponsible } from '@/scopes/account/group-responsible/pages'
import { MarketingPreferences } from '@/scopes/account/marketing-preferences/pages'
import { UserProfile } from '@/scopes/account/user-profile/pages'
import { Auth } from '@/scopes/auth/pages/Auth'
import { SetPassword } from '@/scopes/auth/pages/SetPassword'
import { VerifyAccount } from '@/scopes/auth/pages/VerifyAccount'
import CheckoutConfirmationPage from '@/scopes/checkout/pages/Confirmation'
import GroupsCheckoutConfirmationStep from '@/scopes/checkout/pages/groups/Confirmation'
import GroupsCheckoutOverviewStep from '@/scopes/checkout/pages/groups/OverviewStep'
import GroupsCheckoutPersonalDetails from '@/scopes/checkout/pages/groups/PersonalDetailsStep'
import GroupsCheckoutStep1 from '@/scopes/checkout/pages/groups/Step1'
import MandatoryPayment from '@/scopes/checkout/pages/MandatoryPayment'
import RyanairConfirm from '@/scopes/checkout/pages/RyanairConfirm'
import CheckoutPageStep2 from '@/scopes/checkout/pages/Step2'
import CheckoutPageStep3 from '@/scopes/checkout/pages/Step3'
import AllDestinations from '@/scopes/destinations/pages/AllDestinations'
import Destination from '@/scopes/destinations/pages/Destination'
import { FavoritePage } from '@/scopes/favourites/pages/FavoritePage'
import AccommodationPage from '@/scopes/products/pages/AccommodationPage'
import NewSearchPage from '@/scopes/search/search/pages/SearchPage/SearchPage'
import CheckoutPageStep1 from '../scopes/checkout/pages/Step1'

const reactHybridPageRegistry = createReactHybridPageRegistry()
reactHybridPageRegistry.register(TEMPLATE_NAMES.HomePage)
reactHybridPageRegistry.register(TEMPLATE_NAMES.BrandSummerHomePage)
reactHybridPageRegistry.register(TEMPLATE_NAMES.BrandWinterHomePage)
reactHybridPageRegistry.register(TEMPLATE_NAMES.ContentPage)
reactHybridPageRegistry.register(TEMPLATE_NAMES.CollectionPage)

const reactPageRegistry = createReactPageRegistry()
// TODO Create new ReactAccomodation Page
reactPageRegistry.registerByRule(isPDP, AccommodationPage)
reactPageRegistry.registerByRule(isDestinationPage, Destination)

reactPageRegistry.register('search-page', NewSearchPage)
reactPageRegistry.register('favorite-page', FavoritePage)
reactPageRegistry.register('booking-step-1', CheckoutPageStep1)
reactPageRegistry.register('booking-step-2', CheckoutPageStep2)
reactPageRegistry.register('booking-step-3', CheckoutPageStep3)
reactPageRegistry.register('booking-step-confirmation', CheckoutConfirmationPage)
reactPageRegistry.register('ryanair-confirmation', RyanairConfirm)
reactPageRegistry.register('mandatory-payment', MandatoryPayment)
reactPageRegistry.register('groups-booking-step-1', GroupsCheckoutStep1)
reactPageRegistry.register('groups-booking-step-2', GroupsCheckoutPersonalDetails)
reactPageRegistry.register('groups-booking-step-3', GroupsCheckoutOverviewStep)
reactPageRegistry.register('groups-booking-step-4', GroupsCheckoutConfirmationStep)
reactPageRegistry.register('7f45b2c3-1234-56d7-89ab-cdef01234567', GroupsResponsible)
reactPageRegistry.register('my-profile-page', UserProfile)
reactPageRegistry.register('auth-page', Auth)
reactPageRegistry.register('set-password-page', SetPassword)
reactPageRegistry.register('verify-account-page', VerifyAccount)
reactPageRegistry.register('marketing-preferences-page', MarketingPreferences)
reactPageRegistry.register('my-overview-page', BookingsOverview)
reactPageRegistry.register('booking-details', BookingDetails)
reactPageRegistry.register('booking-payment-page', BookingPaymentPage)
reactPageRegistry.register('groups-winter-booking-payment-page', GroupsWinterBookingPaymentPage)
reactPageRegistry.register('groups-totallysnow-booking-payment-page', GroupsTotallySnowBookingPaymentPage)
reactPageRegistry.register('destination', Destination)
reactPageRegistry.register('destinations', AllDestinations)

reactPageRegistry.register('acco-page', AccommodationPage)

export { reactHybridPageRegistry, reactPageRegistry }
